import { render, staticRenderFns } from "./ArmorClassDisplay.vue?vue&type=template&id=033edbcc&scoped=true"
import script from "./ArmorClassDisplay.vue?vue&type=script&lang=js"
export * from "./ArmorClassDisplay.vue?vue&type=script&lang=js"
import style0 from "./ArmorClassDisplay.vue?vue&type=style&index=0&id=033edbcc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033edbcc",
  null
  
)

export default component.exports